<template>
  
  <ContentsProductHighPerformancePageTitle title="PA46" />

  <section class="section-product-detail-page" >
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/high-performance-plastics/pa4601.jpg"
            :contents="[
              'Improved wear & friction over PA66, high abrasion, high stiffness and toughness, good heat and oil aging, low creep, good fatigue, very good flowability, good mechanical properties under high temperatures',
            ]"
            :is-reverse="true"
            left-width="43.444%"
            right-width="56.252%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/high-performance-plastics/pa4602.jpg"
            credit="Photo credit : https://www.marklines.com"
            :contents="[
              'Gear, moving parts, actuator, connector, complex shape part, motor, air duct, manifold',
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :partners="[
            {
              name: 'DSM',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-dsm.jpg',
              }
            }
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title: 'pa46 - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>

.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>